import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { selectAccessorySizes } from '@ff-scene-plugins/photo-prints-redux/selectors/sizeSelectors';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import classNames from "classnames";
import styles from "./DraggingTooltip.module.scss";

interface DraggingTooltipProps {
    className?: string;
    accessoryId?: string;
    frameId?: string;
    isClickActive?: boolean;
    isDragging?: boolean;
}

export const DraggingTooltip = ({ className = "", accessoryId = "", frameId = "", isClickActive, isDragging }: DraggingTooltipProps) => {

    const { t } = useTranslation();
    const accessories = useSelector((state: PhotoPrintsPdpState) => selectAccessorySizes(state));

    const accessory = accessories.find(accessory => accessory.id === accessoryId)!;
    const minimumQuantity = accessory?.minimumQuantity ?? 1;
    const accessorySingle = minimumQuantity === 1;
    const accessoryMultiple = minimumQuantity > 1;

    const draggingTooltipClass = classNames(styles.draggingToolTip, className);

    return (
        <div className={draggingTooltipClass} >
            <p className={styles.draggingTooltipCopy}>
                {frameId && (isClickActive ? t('photo_prints.click_to_apply_frame') : t('photo_prints.drag_to_apply_frame'))}
                {accessoryId && accessorySingle && (isClickActive ? t('photo_prints.click_to_apply_accessory_to_photo') : t('photo_prints.drag_to_apply_accessory_to_photo'))}
                {accessoryId && accessoryMultiple && (isClickActive ? t('photo_prints.click_to_apply_accessory_to_group') : t('photo_prints.drag_to_apply_accessory_to_group'))}
            </p>
        </div>
    );
};